import axios from 'axios';
import { adios } from '@adserve/adserve-react-components';
import { pad2 } from '../helpers';
import { starter2Api } from '../../../constants/Endpoint';

// ====================

const getBaseUrl = () => starter2Api;
const getDateString = (date) => new Date(date).toISOString().split('T')[0];

// ====================

export const getTransmittersList = (setTransmittersList) => {
    const url = `${starter2Api}/transmitters/selectlist`;

    console.log(':dalurl ', url)

    adios(() => axios(url))
        .then((response) => {
            console.log(':dal ', response)
            const data = response.data ?? [];
            const sorted = data.sort((a, b) => a.name.localeCompare(b.name));
            setTransmittersList(
                sorted.filter((t) => t.isActive && !t.isPlayout)
            );
        })
        .catch((er) => {
            console.error('Error fetching Transmitters SelectList: ', er);
        });
};

export const getLogDayReport = (logId, date, setLogDayReport) => {
    const url = `${getBaseUrl()}/ScheduledSpots/LogDayReport/${logId}/${getDateString(
        date
    )}`;

    adios(() => axios(url))
        .then((response) => {
            const data = response.data.data ?? [];
            setLogDayReport(data);
        })
        .catch((e) => {
            console.error('Error fetching LogDayReport: ', e);
        });
};
export const getLiveContentDayReport = (
    logId,
    date,
    setLiveContentDayReport
) => {
    const spotTypeNames = [
        'LiveRead',
        'Promotion',
        'Airtime',
        'Advertorial',
        'Feature',
        'Sponsorship'
    ];
    const url = `${getBaseUrl()}/SandPPropertySpots/LiveContentDayReport/${logId}/${getDateString(
        date
    )}`;

    adios(() => axios(url))
        .then((response) => {
            const data = response.data.data ?? [];
            data.sort((a, b) => (a.startTimeHrs > b.startTimeHrs ? 1 : -1));
            for (let row of data) {
                row.spotTypeName = row.spotType;
                const padHrs = pad2(row.startTimeHrs);
                const padMins = pad2(row.startTimeMins);
                row.startTimeLabel = `${padHrs}:${padMins}`;
                const padEndHrs = pad2(row.endTimeHrs);
                const padEndMins = pad2(row.endTimeMins);
                row.endTimeLabel = `${padEndHrs}:${padEndMins}`;
            }
            setLiveContentDayReport(data);
        })
        .catch((e) => {
            console.error('Error fetching LiveContentDayReport: ', e);
        });
};
